import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // මෙතන App.js එක හරියටම Link වෙනවා

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);